<div
  id="button"
  [class.is-mobile]="isMobile"
  [class.is-static]="isStatic"
  [class.is-disabled]="isDisabled"
  [class.is-loading]="isLoading"
  (click)="handleOnClick()"
>
  <div class="darken-shape">
    <i *ngIf="_icon" class="icon" [ngClass]="_icon"></i>
    <ng-container *ngIf="isLoading; else default">
      {{ 'Button.Processing' | translate }}
    </ng-container>
    <ng-template #default>{{ text | translate }}</ng-template>
  </div>
</div>
